import { apiClient } from './api';
import { API_BASE_URL } from '../config';

export interface UserProfileData {
  firstName?: string;
  lastName?: string;
  avatar?: string;
  email?: string;
}

export interface UserProfileStatsData {
  sessionsPerWeek: { week: string; weekLabel: string; count: number }[];
  totalWeightMoved: number;
  totalSessions: number;
  memberSince: string | null;
}

export class UserProfileService {
  static async updateProfile(data: { firstName?: string; lastName?: string }): Promise<UserProfileData> {
    const response = await apiClient.put<UserProfileData>('/api/user-profile', data);
    return response.data;
  }

  static async changePassword(data: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }): Promise<{ success: boolean; message: string }> {
    const response = await apiClient.post<{ success: boolean; message: string }>(
      '/api/user-profile/change-password',
      data,
    );
    return response.data;
  }

  static async uploadAvatar(file: File): Promise<{ success: boolean; url: string }> {
    const formData = new FormData();
    formData.append('image', file);
    const response = await fetch(`${API_BASE_URL}/api/user-profile/avatar`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Upload failed');
    }
    return response.json();
  }

  static async getStats(): Promise<UserProfileStatsData> {
    const response = await apiClient.get<UserProfileStatsData>('/api/user-profile/stats');
    return response.data;
  }
}
